import { useMemo } from 'react';
/** Stable primitive deps so the memoized user object doesn't churn on every session reference change. */
export const useAnalyticsUser = (session) => {
    const id = session?.user?.id;
    const orgId = session?.user?.org_uuid ?? undefined;
    const subscriptionStatus = session?.user?.subscription_status;
    return useMemo(() => ({ id, orgId, subscription_status: subscriptionStatus }), [id, orgId, subscriptionStatus]);
};
//# sourceMappingURL=useAnalyticsUser.js.map